import { t } from "@travily/i18n";
import { ButtonGroup, ButtonGroupItem } from "@ui/components/ButtonGroup";
import { firstSelectedKey } from "@ui/lib/selection";
import type { Selection } from "@ui/primitives/shared";

export type MarketplaceTypeFilterValue = "all" | "Product" | "Service";

// i18n-tasks-use t('components.views.shared.marketplace_search.type_all')
// i18n-tasks-use t('components.views.shared.marketplace_search.type_products')
// i18n-tasks-use t('components.views.shared.marketplace_search.type_services')
const OPTIONS: { label: string; value: MarketplaceTypeFilterValue }[] = [
  { label: "components.views.shared.marketplace_search.type_all", value: "all" },
  { label: "components.views.shared.marketplace_search.type_products", value: "Product" },
  { label: "components.views.shared.marketplace_search.type_services", value: "Service" },
];

export interface MarketplaceTypeFilterProps {
  onChange: (value: MarketplaceTypeFilterValue) => void;
  value: MarketplaceTypeFilterValue;
}

export function MarketplaceTypeFilter({ onChange, value }: MarketplaceTypeFilterProps) {
  const handleSelectionChange = (keys: Selection) => {
    const selected = firstSelectedKey(keys);
    if (selected) onChange(selected as MarketplaceTypeFilterValue);
  };

  return (
    <ButtonGroup
      aria-label={t("components.views.shared.marketplace_search.type_label")}
      disallowEmptySelection
      onSelectionChange={handleSelectionChange}
      selectedKeys={new Set([value])}
      selectionMode="single"
      size="lg"
    >
      {OPTIONS.map((option) => (
        <ButtonGroupItem id={option.value} key={option.value}>
          {t(option.label)}
        </ButtonGroupItem>
      ))}
    </ButtonGroup>
  );
}
